import { createToaster } from '@meforma/vue-toaster';

/**
 * Позиция top (центр верха): дефолтный bottom-right ложится поверх футеров
 * правых side pane / корзины шахматки и перехватывает клики по их кнопкам.
 */
const toaster = createToaster({
  position: 'top',
});

export const useToast = () => {
  const show = (msg: string) => {
    toaster.show(msg);
  };

  const error = (msg: string) => {
    toaster.error(msg);
  };

  const success = (msg: string) => {
    toaster.success(msg);
  };

  return { show, error, success };
};
